export const MetadataText = ({ children }: { children: React.ReactNode }) => {
    return <p className="m-0 text-sm text-slate-700 dark:text-portfolio-white">{children}</p>;
};
